export default __webpack_public_path__ + "static/media/setting_6.fbcd326d.png";